import React from 'react'
import RegisterAndLoginForm from '../components/user/RegisterAndLoginForm';
import './Signin.css';
import { getDefaultValue } from '../utils';
import { useStateValue } from '../StateProvider';
import SocialLogin from '../components/forms/user/SocialLogin';

export default function SignIn() {

    const [{ translations }] = useStateValue();
    const translate = (str) => {
        if (!translations) return str;
        var translate = translations.find(x => x.key == str);

        if (translate) return getDefaultValue(translate);
        else return "#" + str;
    };

    const orLabel = translate('or');
    const orText = orLabel.startsWith('#') ? 'or' : orLabel;

    return (
        <div className="signin-page-dark mt-5">
            <section className="signin-dark-body text-color-light signin-dark-body--full">
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-md-8">
                            <p className="text-center text-color-light opacity-8 mb-4 lan-kfont">
                                {"Please sign up or sign in to participate"}
                            </p>
                            <RegisterAndLoginForm embedded />
                            <div className="signin-or-divider" role="separator">
                                <span>{orText}</span>
                            </div>
                            <div className="text-center signin-google-row">
                                <SocialLogin hideIntro />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
